import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, Button, Typography, App, Grid } from "antd";
import { PrinterOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import EmiDueFilters from "./component/EMIDueFilters";
import EmiDueTable from "./component/EMIDueTable";
import EmiDuePrintView from "./component/EmiDuePrintView";
import ReportDom from "../../../components/common/ReportDom";

const { Title } = Typography;

const EmiDueReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { list, filters } = useSelector((state) => state.emiDue);

  const reportRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "EMI Due List Report",
    removeAfterPrint: true,
  });

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }}>EMI Due List</Title>
            </div>
          }
          extra={
            list.length > 0 && (
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                { !screens.xs && "Print" }
              </Button>
            )
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        >
          <EmiDueFilters messageApi={message} />
        </Card>

        <Card className="shadow-md rounded-xl">
          <EmiDueTable />
        </Card>
      </App>

      {/* <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <EmiDuePrintView ref={reportRef} />
      </div> */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Customer Ledger Report"
          mode="no-title"          
          filters={filters}
          renderTable={() => <EmiDuePrintView printMode={true} />}
        />
      </div>
    </div>
  );
};

export default EmiDueReport;